export default {
  /////////////////
  // COMPANY OBJECTS
  /////////////////

  // SET_COMPANY_OBJECTS(state, objects) {
  //   state.objects = objects
  // },
  // ADD_COMPANY_OBJECTS(state, objects) {
  //   state.objects.push(objects)
  // },
  // EDIT_COMPANY_OBJECTS(state, value) {
  //   const userIndex = state.objects.findIndex((u) => u.id === value.id)
  //   state.objects.splice(userIndex, 1, value)
  // },
  SET_WATER_DEPOSITS_TABLE(state, data) {
    state.waterDepositsTable = data;
  },
  SET_WATER_DEPOSITS_MAP(state, data) {
    state.waterDepositsMap = data;
  },
  SET_WATER_INTAKES_TABLE(state, data) {
    state.waterIntakesTable = data;
  },
  SET_WATER_INTAKES_MAP(state, data) {
    state.waterIntakesMap = data;
  },
  SET_APPROVED_SITES_TABLE(state, data) {
    state.approvedSitesTable = data;
  },
  SET_APPROVED_SITES_MAP(state, data) {
    state.approvedSitesMap = data;
  }
};
